<template lang="pug">
  v-menu(:ripple="false" offset-y)
    template(v-slot:activator="{ on }")
      v-btn(v-on="on", depressed, text, :ripple="false")
        span.btn-city.text-capitalize {{ language }}
        v-icon(small) expand_more
    v-list
      v-list-item(
        v-for="(item, index) in languageList"
        :key="index"
        @click="changeLanguage(item)")
        v-list-item-title {{ item }}
</template>
<script>
export default {
  data: () => ({
    languageList: ['ru', 'kg']
  }),
  computed: {
    language: {
      get() {
        return this.$store.state.language
      },
      set(language) {
        this.$store.dispatch('SET_LANGUAGE', language)
      }
    }
  },
  methods: {
    changeLanguage(languageId) {
      // console.log(languageId)
      this.language = languageId
      this.$i18n.locale = languageId
    }
  }
}
</script>
